import { Component, type ReactNode } from 'react';

export class PublicRouteBoundary extends Component<{ children: ReactNode; onOpenTrips(): void }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (!this.state.failed) return this.props.children;
    return <section className="section narrow" role="alert"><h1>안내를 열지 못했어요</h1><p>연결이 끊겼거나 새 안내를 내려받지 못했어요. 저장된 여행과 준비물은 그대로예요.</p><div className="hero-actions"><button className="button primary" onClick={() => window.location.reload()}>연결 후 다시 열기</button><button className="button secondary" onClick={this.props.onOpenTrips}>저장된 여행 보기</button></div></section>;
  }
}
